import { render, staticRenderFns } from "./AdminObrociTab.vue?vue&type=template&id=b901c286"
import script from "./AdminObrociTab.vue?vue&type=script&lang=js"
export * from "./AdminObrociTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports